import axios from 'axios';

const getAxiosInstance = () => {
  return axios.create({
    baseURL: '/',
  });
};

const _axios = getAxiosInstance();

export { getAxiosInstance, _axios as axios };
